// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import claim from './normal-claim';
import {combineReducers} from 'redux';
import confirmationModal from './confirmation-modal';
import createClaimModal from './create-claim-modal';
import customer from './customer';
import failureModes from './failure-modes';
import formValidation from './form-validation';
import isActionButtonDisabled from './is-action-button-disabled';
import isCopied from './is-copied';
import isEditable from './is-editable';
import isNonTrackedPinModalVisible from './is-non-tracked-pin-modal-visible';
import isStickyHeaderVisible from './is-sticky-header-visible';
import isValidClaim from './is-valid-claim';
import pin from './pin';
import product from './product-details';
import showApplyTravel from './show-apply-travel';
import temporaryObjectKey from './temporary-object-key';
import updateShowApplyTravel from './update-show-apply-travel';
import warrantyStatusModal from './warranty-status-modal';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claim,
    confirmationModal,
    createClaimModal,
    customer,
    failureModes,
    formValidation,
    isActionButtonDisabled,
    isCopied,
    isEditable,
    isNonTrackedPinModalVisible,
    isStickyHeaderVisible,
    isValidClaim,
    pin,
    product,
    showApplyTravel,
    temporaryObjectKey,
    updateShowApplyTravel,
    warrantyStatusModal
});



// WEBPACK FOOTER //
// ./src/claim/normal/reducers/index.js